import React, { useState, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Divider,
  Button,
  Spin,
  Collapse,
} from "antd";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { PROCURING_ENTITY_REPORTS_ENDPOINT } from "../../../../../API/endpoints";
import API from "../../../../../API";
import { isoDateToHumanReadableDate } from "../../../../../Util";
import { AppContext } from "../../../../../context/AppContext";
import "./style.css";
import { useCallback } from "react";

const { Panel } = Collapse;

const { Title, Paragraph } = Typography;

const ReportSummary = () => {
  const [report, setReport] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeKeys, setActiveKeys] = useState(["0"]);

  const { selectedReportID, setSelectedReportID } = useContext(AppContext);

  const handlePanelChange = (keys) => {
    setActiveKeys(keys);
  };

  const getReports = useCallback(async (id) => {
    setIsLoading(true);
    const response = await API.get(
      `${PROCURING_ENTITY_REPORTS_ENDPOINT}/${selectedReportID}`
    );
    setReport(response);
    const recommensDationsdata = response?.recommendations?.map(
      (item, index) => ({
        title: `#Recommendation:`,
        content: item.recommendation,
      })
    );
    setRecommendations(recommensDationsdata);
    setIsLoading(false);
  }, [selectedReportID]);

  useEffect(() => {
    getReports();
  }, [getReports, selectedReportID, setSelectedReportID]);

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 54,
      }}
      spin
    />
  );

  if (isLoading) {
    return (
      <Spin
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        indicator={antIcon}
      />
    );
  }

  return (
    <div style={{ padding: "24px", backgroundColor: "#f0f2f5" }}>
      {/* Report Overview Header */}
      <Row gutter={16} align="middle">
        <Col span={24}>
          <Title level={2} style={{ color: "#0f6788", marginBottom: "0" }}>
            Report Overview and others
          </Title>
        </Col>
      </Row>

      {/* Report Details with Download Button */}
      <Row gutter={16} align="middle" style={{ marginBottom: "12px" }}>
        <Col span={16}>
          <Title
            level={3}
            style={{ color: "#000", fontSize: "1.1rem", fontWeight: "300" }}
          >
            {report?.report_title}
          </Title>
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            style={{
              backgroundColor: "#0f6788",
              borderColor: "#0f6788",
              padding: "0 24px",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              marginBottom: "12px",
            }}
            disabled={!report?.document_url}
          >
            {report?.document_url ? (
              <a
                href={report.document_url}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "inherit", textDecoration: "none" }}
                download
              >
                {`Download report no. ${report?.report_number}`}
              </a>
            ) : (
              `Download report no. ${report?.report_number}`
            )}
          </Button>
          <Paragraph style={{ margin: 0 }}>
            <strong style={{ color: "#0f6788" }}>Report Period:</strong>{" "}
            {isoDateToHumanReadableDate(report?.start)} {" - "}
            {isoDateToHumanReadableDate(report?.end)}
          </Paragraph>
        </Col>
      </Row>

      <Divider style={{ borderColor: "#d4d4d4", margin: "12px 0" }} />

      {/* Executive Summary */}
      <Row gutter={16}>
        <Col span={24}>
          <Card
            bordered={false}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              padding: "12px",
              marginBottom: "12px",
            }}
          >
            <Title level={4} style={{ color: "#0f6788" }}>
              Executive Summary
            </Title>
            <Paragraph>{report?.summary}</Paragraph>
          </Card>
        </Col>
      </Row>

      <Divider style={{ borderColor: "#d4d4d4", margin: "12px 0" }} />

      {/* General Recommendation */}
      <Row gutter={16}>
        <Col span={24}>
          <Card
            bordered={false}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              marginBottom: "12px",
              padding: "12px",
            }}
          >
            <Title level={4} style={{ color: "#0f6788" }}>
              General Recommendations
            </Title>
            {/* <Paragraph>{report?.summary}</Paragraph> */}
            <Collapse
              bordered={false}
              defaultActiveKey={["0"]}
              expandIconPosition={"end"}
              className="collapse-menu subtle-box-shadow"
              onChange={handlePanelChange}
            >
              {recommendations?.map((item, index) => (
                <Panel
                  header={
                    <span className="recommendation-tittle">
                      {item.title}
                      {!activeKeys.includes(String(index)) && (
                        <span className="content-preview">
                          {" - " +
                            (item.content?.length > 40
                              ? item.content.substring(0, 40) + "..."
                              : item.content)}
                        </span>
                      )}
                    </span>
                  }
                  key={index}
                  className="collapse-header"
                >
                  <p>{item.content}</p>
                </Panel>
              ))}
            </Collapse>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ReportSummary;
